import { useState } from '@wordpress/element';
import { BlockControls, MediaUpload } from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import {VayuBlockLinkBlockControl} from '@vayu-blocks';
import noimagelong from "../../../../../../inc/assets/img/no-image-long.png";
import { __ } from '@wordpress/i18n';
import {CopyPasteStyles} from '@vayu-blocks';

const ImageToolbar = ({ attributes ,setAttributes}) => {
    if (!attributes.image || attributes.typeimage !== "image") return null;

    const [rotation, setRotation] = useState(attributes.rotation);

    const rotateImage = () => {
        const newRotation = (rotation + 90);
        setRotation(newRotation);
        setAttributes({ rotation: newRotation });
    };

    // Function to handle image selection/change
    const handleImageChange = ( media ) => {

        if(attributes. parentBlock === 'vayu-blocks/advance-slider' && attributes.image != noimagelong){
            setAttributes({overlayshow:false})
        }

        if (media && media.url) {
            setAttributes({ image: media.url });
        }

    };

    return (
        <>
            <BlockControls>
                <ToolbarGroup>
                    <ToolbarButton
                        label="Rotate Image"
                        onClick={rotateImage}
                    >
                        <span
                            style={{
                                display: 'inline-block',
                                transform: `rotate(${attributes.rotation}deg)`,
                                transition: 'transform 0.3s ease-in-out'
                            }}
                            className="dashicons dashicons-image-rotate"
                        ></span>
                    </ToolbarButton>
                    </ToolbarGroup>
                    <ToolbarGroup>
                    <MediaUpload
                        onSelect={handleImageChange}
                        allowedTypes={['image']}
                        render={({ open }) => (
                            <ToolbarButton
                                label="Change Image"
                                onClick={open}
                                icon="plus"
                                className='vb-toolbar-align'
                            >
                               {__('Replace', 'vayu-blocks')}
                            </ToolbarButton>
                        )}
                    />
                </ToolbarGroup>
            </BlockControls>

            <VayuBlockLinkBlockControl
                value={attributes.link}
                attributeKey="link"
                onChange={(key, value) => setAttributes({ [key]: value })}
            />

            <BlockControls>
                <CopyPasteStyles exclude={['image']} attributes={attributes} setAttributes={setAttributes} blockName={'vayu-blocks/image'}/>
            </BlockControls>
        </>
    );
};

export default ImageToolbar;
